/* Numero di elementi per pagina
10 | 25 | 50 | 100
*/
import { createContext } from "react";
const SelectedPageSizeContext = createContext({
    selectedPageSize: 10,
    setSelectedPageSize: (pageSize) => {}
  });
export default SelectedPageSizeContext;